<template>
  <div id="app">
    <side-bar />
    <main id="main" ref="main" @scroll.passive="hideAndShowButtonToTop">
      <top-bar />
      <transition>
        <router-view :key="$route.fullPath" />
      </transition>
    </main>
    <footer-section />
    <div v-if="loading" class="loader">
      <div>
        <b-spinner type="grow" variant="light" label="Spinning" />
        <strong class="w-100 d-block mt-5 text-light text-center">{{$t('pleaseWait')}}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SideBar from './components/partials/SideBar.vue'
import TopBar from './components/partials/TopBar.vue'
import FooterSection from './components/partials/Footer.vue'

export default {
  components: {
    SideBar,
    TopBar,
    FooterSection
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  methods: {
    hideAndShowButtonToTop () {
      const main = document.getElementById('main')
      if (main.scrollTop > 20 || main.scrollTop > 20) {
        document.getElementById("btnToTop").style.display = "block";
      } else {
        document.getElementById("btnToTop").style.display = "none";
      }
    }
  }
}
</script>
